module.exports = __webpack_public_path__ + "static/img/spfm.c09efd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/spfm.png
// module id = 65
// module chunks = 3